import React, { useEffect, useRef, useState } from 'react';
import { AppColumn, AppRow } from '../../../UI/Layouts';
import { SizedBox } from '../../../UI/Sizes';
import useTheme from '../../../../hooks/useTheme';
import AppText from '../../../UI/Texts/AppTexts';
import { t } from 'i18next';
import { useResponsive } from '../../../UI/ResponsiveContext';
import { Grid, Icon } from 'semantic-ui-react';
import JobCard from '../../JobListingsPage/Components/JobCard';
import { AppPrimaryButton } from '../../../UI/CustomButtons';
import { generateLandingSearchUrl, getLocale } from '../../../../utils/helperFunctions';
import { useSelector } from 'react-redux';

const OtherJobs = ({ jobs, availableJobs }) => {
    const theme = useTheme();

    const coreState = useSelector((state) => state.core);
    const constants = coreState?.constants;

    const queryData = availableJobs?.queryData;

    const locationData = queryData?.location;
    const roleData = queryData?.role;

    const { isMobile } = useResponsive();

    if (jobs?.length === 0) {
        return (<div />)
    }

    return (
        <AppColumn>
            <AppText.SubHeading fontWeight={600} margins={{
                marginTop: '0px',
                marginBottom: '0px',
            }} use={'h2'}>
                {t('availablejobs.role.location.all_jobs.title', {
                    role: roleData?.text[getLocale()]?.toLowerCase(),
                    location: locationData?.name,
                })}
            </AppText.SubHeading>
            <SizedBox height={theme.spacing.elementPadding} />
            <Grid stackable columns={2} divided={isMobile}
            >
                {jobs.length > 0 &&
                    jobs.map((job, index) => (
                        <Grid.Column
                            key={`${job.jobId}_${index}`}
                        >
                            <JobCard uniqueKey='job-category' jobData={job} />
                        </Grid.Column>
                    ))}
            </Grid>
            <SizedBox height={theme.spacing.contentElementPadding} />
            <AppPrimaryButton
                size='big'
                href={`/${generateLandingSearchUrl({
                    constants: constants,
                    workroles: roleData && [roleData?.roleId],
                    locations: locationData && [locationData?.key],
                })}`}
                target="_blank"
                style={{
                    borderRadius: theme.radius.default,
                    width: isMobile && '100%',
                }}
                outline
            >{
                    t("see_all")}
                <Icon name="arrow right" style={{
                    marginLeft: isMobile ? '0px' : '5px',
                    color: theme.primaryColor,
                    paddingLeft: theme.spacing.elementPadding,
                }} />
            </AppPrimaryButton>
            <SizedBox height={theme.spacing.contentPaddingBig} />
        </AppColumn>
    );
}

export default OtherJobs;